import React from 'react'
import { CustomerText } from '../CustomerText'
import QuestionHelp from './Components/QuestionHelp'
import TextInput from './Components/TextInput'
import Config from '../Config'
import Icons from './Images';
const { Language, platform, Pushgtagpiwikurl, Pushgtagdata } = Config()


export class QuestionTop extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    render() {
        let { hotTopics, categories, RouterDetail, RouterFeedback, RouterSearch } = this.props
        let tempText = CustomerText[Language]
        let specical = Array.isArray(hotTopics) && hotTopics.length > 0 && hotTopics.map(v => v.title).join('').length > 130
        return <div className="questionTopContainer">
            <div className="searchBox">
                <div className="searchBgBox">
                    <img
                        src={Icons[`search${platform}Bg`]}
                        className="searchBg"></img>
                    <div className="searchInput">
                        <TextInput
                            tempText={tempText}
                            onClick={() => {
                                RouterSearch()

                                Pushgtagpiwikurl('help_center', 'Help Center')
                                Pushgtagdata('HelpCenter', 'Go to Search Help Center', 'HelpCenter_C_Search')
                            }}></TextInput>
                    </div>
                </div>

                {
                    <div className="hotListBox">
                        <div className="hotListTitle">{tempText?.text5}</div>
                        <div className={`hotListWrap hotListWrap${(specical && platform == 'Web') ? 'specical' : ''}`}>
                            {
                                Array.isArray(hotTopics) && !!hotTopics.length && hotTopics.map((v, i) => {
                                    return <div
                                        key={i}
                                        onClick={() => {
                                            RouterDetail({
                                                type: 'hot',
                                                tempData: v,
                                                piwikType: 'hot'
                                            })
                                        }}
                                        className="hotList"
                                    >
                                        <div className="hotListText">{v.title}</div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                }
            </div>

            <QuestionHelp
                tempText={tempText}
                RouterFeedback={RouterFeedback}
                fromPage='Question'
            ></QuestionHelp>

        </div>


    }
}

export class QuestionBottom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    render() {
        let { hotTopics, categories, RouterDetail, RouterFeedback, RouterSearch, tempCategories } = this.props
        let tempText = CustomerText[Language]
        return <div className="questionBottomContainer">
            {
                Array.isArray(categories) && !!categories.length && <div className="knowledgeCategoriesBox">
                    {
                        categories.map((v, i) => {
                            let flag = tempCategories?.categoryName == v.categoryName
                            return <div
                                key={i}
                                onClick={() => {
                                    let isOnlyOne = v?.articles?.length == 1
                                    RouterDetail({
                                        type: isOnlyOne ? 'hot' : 'general',
                                        tempData: isOnlyOne ? (v?.articles[0] || {}) : v,
                                        piwikType: 'general',
                                        piwikTitle: v?.categoryName
                                    })
                                }}
                                className={`knowledgeCategoriesList ${flag ? `knowledgeCategoriesListActive` : ''}`}
                            >
                                <div className="knowledgeCategoriesText">{v.categoryName}</div>
                                <img
                                    src={Icons.rightArrow}
                                    className={`rightArrow ${platform == 'Web' ? 'hide' : 'https://arcadie.atlassian.net/browse/CUSP-40'}`}
                                ></img>
                            </div>
                        })
                    }
                </div>
            }
        </div>
    }
}